/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * What the mapping matches: a directory group or an attribute value.
 */
export const AccessMemberDirectoryRoleSourceSourceKind = {
  Group: "group",
  Attribute: "attribute",
} as const;
/**
 * What the mapping matches: a directory group or an attribute value.
 */
export type AccessMemberDirectoryRoleSourceSourceKind = ClosedEnum<
  typeof AccessMemberDirectoryRoleSourceSourceKind
>;

/**
 * One directory role mapping that currently gives a member a role. Attribute keys and values are not included: they can carry personal directory data, so admins resolve them through listDirectoryRoleMappings by mapping_id.
 */
export type AccessMemberDirectoryRoleSource = {
  /**
   * The mapped directory group. Set when source_kind is group.
   */
  directoryGroupId?: string | undefined;
  /**
   * The directory role mapping.
   */
  mappingId: string;
  /**
   * The role the mapping grants.
   */
  roleId: string;
  /**
   * What the mapping matches: a directory group or an attribute value.
   */
  sourceKind: AccessMemberDirectoryRoleSourceSourceKind;
};

/** @internal */
export const AccessMemberDirectoryRoleSourceSourceKind$inboundSchema:
  z.ZodMiniEnum<typeof AccessMemberDirectoryRoleSourceSourceKind> = z.enum(
    AccessMemberDirectoryRoleSourceSourceKind,
  );

/** @internal */
export const AccessMemberDirectoryRoleSource$inboundSchema: z.ZodMiniType<
  AccessMemberDirectoryRoleSource,
  unknown
> = z.pipe(
  z.object({
    directory_group_id: z.optional(z.string()),
    mapping_id: z.string(),
    role_id: z.string(),
    source_kind: AccessMemberDirectoryRoleSourceSourceKind$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "directory_group_id": "directoryGroupId",
      "mapping_id": "mappingId",
      "role_id": "roleId",
      "source_kind": "sourceKind",
    });
  }),
);

export function accessMemberDirectoryRoleSourceFromJSON(
  jsonString: string,
): SafeParseResult<AccessMemberDirectoryRoleSource, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AccessMemberDirectoryRoleSource$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AccessMemberDirectoryRoleSource' from JSON`,
  );
}
